<template>
  <div class="about">
    <VideoSection :Video="Model"> </VideoSection>

    <!-- <div class="service section-gap pt-5">

			<div class="container">
				<ServiceSection />
			</div>
    </div>-->
    <div
      class="col-sm-2 col-md-2 mx-auto mb-3"
      style="text-align: center"
    >
      <button
        @click="back"
        type="border"
        class="
          btn-primary
          rounded-pill
          text-white
          btn-lg
          rounded-pill
          pl-3
          pr-3
          font-weight-bold
        "
      >
        {{ $t("back") }}
      </button>
    </div>
  </div>
</template>
<script>
import VideoSection from "Components/Sections/VideoSection.vue";
import modulePageDetails from "@/store/PageDetails/modulePageDetails.js";
import { domain } from "@/globalComponents.js";

export default {
  data() {
    return {
      Model: {},
      model: {},
      baseURL: domain,
      isMounted: false,
    };
  },
  components: {
    VideoSection,
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    UpdateStatus(item) {
      if (this.$store.state.auth.isUserLoggedIn()) {
        let model = {};
        model.libraryID = item.ID;
        this.$store
          .dispatch("DataList/ToggleUserFavorite", model)
          .then(() => {
            this.Model.IsFavorite = !this.Model.IsFavorite;
          })
          .catch(() => {});
        return false;
      } else {
        this.$toasted.show(this.$t("PleaseLoginFirst"), {
          theme: "outline",
          position: "bottom-center",
          duration: 5000,
        });
        return true;
      }
    },
  },
  created() {
    debugger;
    if (!modulePageDetails.isRegistered) {
      this.$store.registerModule("DetailsList", modulePageDetails);
      modulePageDetails.isRegistered = true;
    }
    let ID = this.$route.params.ID;

    this.$store
      .dispatch("DetailsList/GetLibrary", ID)
      .then((response) => {
        if (response.status == 200) {
          //   alert("ٍ" + this.model.pageNumber);
          debugger;
          this.Model = response.data.data;
          debugger;
          this.isMounted = true;
        }
      })
      .catch(() => {});
  },
};
</script>
